/* unplugin-vue-components disabled */import script from "./noticeDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./noticeDetails.vue?vue&type=script&setup=true&lang=ts"

import "./noticeDetails.vue?vue&type=style&index=0&id=aafcb18e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aafcb18e"]])

export default __exports__